import React from 'react';
import image1 from '../assets/images/image1.png'
import commaImg from '../assets/images/inverted_comma.svg';
import { MyButton } from './ui/MyButton.js';
import { useNavigate } from "react-router-dom";

const AboutUs = () => {
    const navigate = useNavigate();
    return (
        <div className='sizedbox py-5 text-center'>
            <h2 style={{ color: "var(--text-color)", }}>
                <span
                    style={{
                        background: "var(--primary-gradient-100)",
                        backgroundClip: "text",
                        WebkitTextFillColor: "transparent"
                    }}>
                    About</span>&nbsp;US</h2>
            <p style={{ fontSize: "18px", fontWeight: "400", color: "var(--text-color)", lineHeight: "24px" }}>Empowering Cloud Management: Simplify, Streamline, and Scale with Libcloud</p>

            <div className={`mt-5 row g-2 gap-5 mb-5`}>
                <div className='col-12 col-md-5 text-start'>
                    <img src={image1} alt='about us' style={{ width: "100%", objectFit: "cover", borderRadius: "30px", height: "auto" }}></img>
                    <div className='d-flex align-items-start gap-3 mt-5'>
                        <img src={commaImg} alt='comma' className='mt-2'></img>
                        <h2 style={{ color: "var(--text-color)", width: "75%" }}>
                            Technology partners for your business</h2></div>
                </div>
                <div className='col-12 col-md-5 text-start'>
                    <h3 style={{ color: "var(--text-color)", fontSize: "24px", fontWeight: "500", lineHeight: "30px", marginTop: "1rem" }}>LibCloud:</h3>
                    <p style={{ color: "var(--text-color)", fontSize: "18px", fontWeight: "400", lineHeight: "24px", marginTop: "0.5rem" }}>
                        Apache Libcloud stands as a dynamic Python library, serving as a unified interface across various cloud service providers and their APIs. Simplifying cloud service interaction, it offers an intuitive set of functions for managing virtual machines, storage, load balancers, and more. With Libcloud, coding across multiple cloud providers becomes effortless, eliminating the need to learn each provider's API individually.
                    </p>

                    <h3 style={{ color: "var(--text-color)", fontSize: "24px", fontWeight: "500", lineHeight: "30px", marginTop: "1.2rem" }}>LMS (Learning Management System):</h3>
                    <p style={{ color: "var(--text-color)", fontSize: "18px", fontWeight: "400", lineHeight: "24px", marginTop: "0.5rem" }}>
                        In the realm of education and training, LMS refers to Learning Management System—a software platform integral for managing and delivering online courses and training materials.
                    </p>
                    <div className='mt-auto'>
                        <MyButton btntext="Contact Us" onClick={() => { navigate("/contact") }} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutUs;